import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.6",
      d: "M13.333 3.334c.775 0 1.162 0 1.48.085a2.5 2.5 0 0 1 1.768 1.768c.085.318.085.705.085 1.48v7.667c0 1.4 0 2.1-.272 2.635A2.5 2.5 0 0 1 15.3 18.06c-.534.273-1.235.273-2.635.273H7.333c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.093-1.092c-.272-.535-.272-1.235-.272-2.635V6.667c0-.775 0-1.162.085-1.48a2.5 2.5 0 0 1 1.768-1.768c.318-.085.705-.085 1.48-.085M7.5 12.5l1.666 1.667 3.75-3.75M8 5h4c.466 0 .7 0 .878-.09a.83.83 0 0 0 .364-.365c.091-.178.091-.411.091-.878V3c0-.466 0-.7-.09-.878a.83.83 0 0 0-.365-.364c-.178-.091-.412-.091-.878-.091H8c-.467 0-.7 0-.879.09a.83.83 0 0 0-.364.365c-.09.178-.09.412-.09.878v.667c0 .467 0 .7.09.878.08.157.208.285.364.365C7.3 5 7.533 5 8 5"
    }, null, -1)
  ])))
}
export default { render: render }